import * as actionTypes from '../../redux/actionTypes';

const initialState = {
  locations: [],
  isMore: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SERVICE_PROVIDER_LOADED:
      return { ...state, ...initialState, ...action.data };
    default:
      return state;
  }
};
